export const slides = [
  {
    id: 0,
    image: {
      md: "https://disney.images.edge.bamgrid.com/ripcut-delivery/v2/variant/disney/009BA5A28F3E87780767263281723FCE752D801C650BD0EDF53FC908A074D15A/compose?format=webp&width=1024",
      xl: "https://disney.images.edge.bamgrid.com/ripcut-delivery/v2/variant/disney/5DB72A585849EDA8751529171E2D29278B170A3108CA41FFDF378E98CB81A61F/compose?format=webp&width=1920",
    },
    title: "연간 구독 혜택을 12개월로 넉넉하게 만나보세요",
    status: "",
  },
  {
    id: 1,
    image: {
      md: "https://disney.images.edge.bamgrid.com/ripcut-delivery/v2/variant/disney/D77B548133871A86001FFE0B75E4A9F1B1511AA8EB89FF0778F5B1D7A3708742/compose?format=webp&width=1024",
      xl: "https://disney.images.edge.bamgrid.com/ripcut-delivery/v2/variant/disney/D680DEA400CE043AACF5D04C741FD0CA30C2FCDA75CA898189795B622667111A/compose?format=webp&width=1920",
    },
    title: "운명전쟁 49",
    status: "지금 스트리밍 중",
  },
  {
    id: 2,
    image: {
      md: "https://disney.images.edge.bamgrid.com/ripcut-delivery/v2/variant/disney/BE55F2BD62423F344B50EDD404B18752CB9D008B85657634D9FFB84A4AD9CFDE/compose?format=webp&width=1024",
      xl: "https://disney.images.edge.bamgrid.com/ripcut-delivery/v2/variant/disney/707C98B6AD5153254F813C2BCCD491AF8613A2F84C9761833B235199806C68B7/compose?format=webp&width=1920",
    },
    title: "주토피아 2",
    status: "3월 11일 스트리밍",
  },
  {
    id: 3,
    image: {
      md: "https://disney.images.edge.bamgrid.com/ripcut-delivery/v2/variant/disney/4A620876186617620B6EBD1CBEBC40EF9667D7A64859BDC15A79ADF0476D7FF1/compose?format=webp&width=1024",
      xl: "https://disney.images.edge.bamgrid.com/ripcut-delivery/v2/variant/disney/5234FB83402ACBF37E43B616474778A6924D3C8A76B5974D6F9900700D10B997/compose?format=webp&width=1920",
    },
    title: "클라이맥스",
    status: "3월 16일 스트리밍",
  },
  {
    id: 4,
    image: {
      md: "https://disney.images.edge.bamgrid.com/ripcut-delivery/v2/variant/disney/18DE8F3D146796FB50E3C493BEA16268DFDEF0E98FAE2C59105CC7F746D8A73C/compose?format=webp&width=1024",
      xl: "https://disney.images.edge.bamgrid.com/ripcut-delivery/v2/variant/disney/DDAB017C5682717A90611547680A3FAA5EBDF90F12E411A55E0CEEA5E8602DCD/compose?format=webp&width=1920",
    },
    title: "찬란한 너의 계절에",
    status: "지금 스트리밍 중",
  },
];
